const allItems = document.querySelectorAll('.blog__post.blog-articles__article');
let currentIndex = 0;
const itemsPerLoad = 9;

const itemsContainer = document.querySelector('.blog-articles');
const loadMoreBtn = document.querySelector('.blog-load-more-button');

function loadItems() {
  const itemsToShow = Array.from(allItems).slice(currentIndex, currentIndex + itemsPerLoad);
  
  itemsToShow.forEach(item => {
    item.style.display = 'flex';
  });

  currentIndex += itemsPerLoad;

  if (currentIndex >= allItems.length) {
    loadMoreBtn.style.display = 'none';
  }
}

allItems.forEach(item => {
  item.style.display = 'none';
});

addEventListener('load', function() {
  itemsContainer.classList.remove('opacity-0');  
  
  if (allItems.length <= 9) {
    loadMoreBtn.style.display = 'none';
  } else {
    loadMoreBtn.style.display = 'flex';
  }

  loadItems();
});

loadMoreBtn.addEventListener('click', loadItems);